import { createFileRoute } from '@tanstack/react-router'
import { type EarningsSearch, parseEarningsSearch } from '~/features/earnings/lib/earnings-list'
import { EarningsPage } from '~/features/earnings/ui/earnings-page'
import { type PayoutReturn, parsePayoutReturn } from '~/features/events/tickets/payout-return'
import * as m from '~/paraglide/messages'
import { PageHeader } from '~/widgets/page-header'

export const Route = createFileRoute('/dashboard/earnings')({
  validateSearch: (
    search: Record<string, unknown>,
  ): EarningsSearch & { payouts?: PayoutReturn } => ({
    ...parseEarningsSearch(search),
    payouts: parsePayoutReturn(search.payouts),
  }),
  component: Earnings,
})

function Earnings() {
  const { payouts, ...search } = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <div className="flex w-full flex-col gap-6">
      <PageHeader title={m.earningsTitle()} description={m.earningsDescription()} />
      <EarningsPage
        search={search}
        payoutReturn={payouts}
        onSearchChange={(next) => navigate({ search: next, replace: true })}
      />
    </div>
  )
}
